import { createComponentPreviewMapperModel } from '@wix/editor-elements-integrations';
import {
  composeMapper,
  getDesignPanelPreviewStateMap,
  getPartToPreviewStateMap,
} from '@wix/editor-elements-preview-utils';
import type { PreviewWrapperProps } from '@wix/editor-elements-types/thunderboltPreview';
import type {
  PaginationDefinition,
  PaginationPropsCarmiData,
  IPaginationMapperProps,
} from '../Pagination.types';
import { props as viewerPropsMapper } from './Pagination.mapper';

const props = composeMapper<
  PreviewWrapperProps<IPaginationMapperProps>,
  PaginationDefinition,
  PaginationPropsCarmiData
>()(
  viewerPropsMapper,
  { add: ['compPreviewState', 'componentViewMode'] },
  (resolver, dependencies, carmiData) => {
    const viewerProps = resolver(dependencies, carmiData);
    const { compPreviewState, componentViewMode } = dependencies;

    const designPanelPreviewStateMap =
      getDesignPanelPreviewStateMap(compPreviewState);

    return {
      ...viewerProps,
      previewWrapperProps: {
        compPreviewState,
        componentViewMode,
      },
      partToPreviewStateMap: getPartToPreviewStateMap(
        designPanelPreviewStateMap,
      ),
    };
  },
);

export default createComponentPreviewMapperModel({ props });
